import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InsureRoutingModule } from './insure.routing';

import { MatCardModule } from '@angular/material/card';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatStepperModule} from '@angular/material/stepper';
import { InsureComponent } from './insure.component';
import { InsureQuoteComponent } from './components/insure-quote/insure-quote.component';
import { InsureBuyComponent } from './components/insure-buy/insure-buy.component';
import { InsureManageComponent } from './components/insure-manage/insure-manage.component';
import { InsureHomeComponent } from './components/insure-home/insure-home.component';


@NgModule({
  declarations: [
    InsureComponent,
    InsureQuoteComponent,
    InsureBuyComponent,
    InsureManageComponent,
    InsureHomeComponent
  ],
  imports: [
    CommonModule,
    InsureRoutingModule,
    FormsModule,
    MatCardModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    ReactiveFormsModule
  ]
})
export class InsureModule { }
